export default "__VITE_ASSET__DtXBDa7j__"